import { useState, useEffect } from 'react';
import { materialRequestService } from '../services/materialRequestService';

export const useProjectMaterialRequests = (projectId) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!projectId) return;

    const fetchRequests = async () => {
      setLoading(true);
      try {
        const response = await materialRequestService.getProjectRequests(projectId, 1, 100);
        // The service returns the full Axios response, so data is in response.data
        const responseData = response?.data;
        const reqs = responseData?.requests || responseData?.data || responseData || [];
        setRequests(Array.isArray(reqs) ? reqs : []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRequests();
  }, [projectId]);

  const allDelivered = requests.length > 0 && requests.every((r) => r.status === 'DELIVERED');

  return {
    requests,
    loading,
    error,
    allDelivered
  };
};
